import type { ProviderContextConfig } from '@openx/components-provider/lib/utils/context/ProviderContext';

import { useAccountOptionsFetch } from './utils/useAccountOptionsFetch';
import { useCreateProvider } from './utils/useCreateProvider';
import { useEditProvider } from './utils/useEditProvider';
import { useEditProviderAllowedAccounts } from './utils/useEditProviderAllowedAccounts';
import { useGetProvidersTableData } from './utils/useGetProvidersTableData';
import { useProviderFetch } from './utils/useProviderFetch';
import { useProviderPageHeaderActions } from './utils/useProviderPageHeaderActions';
import { useProvidersListFetch } from './utils/useProvidersListFetch';

export const providerConfig: ProviderContextConfig = {
  isOa: true,
  useAccountOptionsFetch,
  useCreateProvider,
  useEditProvider,
  useEditProviderAllowedAccounts,
  useGetProvidersTableData,
  useProviderFetch,
  useProviderPageHeaderActions,
  useProvidersListFetch,
};
